import { FC, ReactNode } from 'react';

import styles from './index.module.scss';

type Props = {
  children: ReactNode;
};

export const AdminPanelLayout: FC<Props> = ({ children }) => {
  return <div className={styles.root}>{children}</div>;
};
